import { render, staticRenderFns } from "./AdminBUFormEdit.vue?vue&type=template&id=aaade7d2&lang=pug"
import script from "./AdminBUFormEdit.vue?vue&type=script&lang=js"
export * from "./AdminBUFormEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminBUFormEdit.vue?vue&type=style&index=0&id=aaade7d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports